/**
 * ユーティリティ関数とconfig値
 */
class AnyStore {

  constructor() {
    this.ease = {
      //easeIn1: CustomEase.create("customIn", "M0,0 C0.366,0 0.528,0.147 0.664,0.27 0.88,0.464 1,1 1,1"),
      //easeOut1: CustomEase.create("customOut", "M0,0 C0.126,0.382 0.22,0.605 0.374,0.758 0.572,0.954 0.818,1 1,1")
    };

    this.ajustTop = {
      pc: 30,
      sp: 70,
    };

    this.dat_SETTINGS = {
      'duration': {
        min: 0,
        max: 10,
        pitch: 0.1
      },
      'from_opacity': {
        min: 0,
        max: 1,
        pitch: 1
      },
      'from_y': {
        min: 0,
        max: 1000,
        pitch: 50
      },
      'from_rotationX': {
        min: 0,
        max: 360,
        pitch: 1
      },
      'from_skewY': {
        min: 0,
        max: 360,
        pitch: 1
      },
      'from_scaleY': {
        min: 0,
        max: 10,
        pitch: 0.1
      },
      'ease': [
        'Sine.easeIn',
        'Sine.easeOut',
        'Sine.easeInOut',
        'Quad.easeIn',
        'Quad.easeOut',
        'Quad.easeInOut',
        'Cubic.easeIn',
        'Cubic.easeOut',
        'Cubic.easeInOut',
        'Quart.easeIn',
        'Quart.easeOut',
        'Quart.easeInOut',
        'Quint.easeIn',
        'Quint.easeOut',
        'Quint.easeInOut',
        'Expo.easeIn',
        'Expo.easeOut',
        'Expo.easeInOut',
        'Circ.easeIn',
        'Circ.easeOut',
        'Circ.easeInOut',
        'Back.easeIn',
        'Back.easeOut',
        'Back.easeInOut',
        'Elastic.easeIn',
        'Elastic.easeOut',
        'Elastic.easeInOut',
        'Bounce.easeIn',
        'Bounce.easeOut',
        'Bounce.easeInOut'
      ]
    };

    this.PARAMS = {
      'duration': 1.4,
      'from_opacity': 1,
      'from_y': 300,
      'from_rotationX': 0,
      'from_skewY': 0,
      'from_scaleY': 2.0,
      'to_opacity': 1,
      'to_y': 0,
      'to_rotationX': 0,
      'to_skewY': 0,
      'to_scaleY': 1.0,
      'ease': 'Expo.easeOut',
      '3d': false,
      'img_tween': true,
    };

    this.$PAGE_MODULE = {};

    this.PC_HOVER_TIMERS = {};
    this.PC_HOVER_CALLBACKS = {};
  }

  addPageModule(id, _module) {
    this.$PAGE_MODULE[id] = new _module();
  }

  addPageModule(id, _module) {
    this.$PAGE_MODULE[id] = new _module();
  }

  /*get(id){
    return this._data.find(d => d.id === id);
  }*/

  getWindowWidth() {
    return (Useragnt.pc && Useragnt.windows) ? document.body.clientWidth : window.innerWidth;
  }

  getClientHeight() {
    return document.documentElement.clientHeight || document.body.clientHeight;
  }

  getScrollTop() {
    return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
  }

  getScrollHeight() {
    return document.documentElement.scrollHeight || document.body.scrollHeight;
  }

  getScrollThreshold() {
    return window.innerHeight * 0.8;
  }

  setPcHoverTimer(callback, id) {
    this.PC_HOVER_TIMERS[`pc_hover_${id}`] = TweenMax.delayedCall(0.4, callback);
    this.PC_HOVER_CALLBACKS[`pc_hover_${id}`] = callback;
  }

  killPcHoverTimer(id) {
    if (this.PC_HOVER_TIMERS[id]) {
      this.PC_HOVER_TIMERS[id].kill();
      this.PC_HOVER_TIMERS[id] = null;
    }
  }

  killAllPcHoverTimer(id) {
    for (let i in this.PC_HOVER_TIMERS) {
      this.killPcHoverTimer(i);

      if (`pc_hover_${id}` != i && this.PC_HOVER_CALLBACKS[i]) {
        console.log('killall',i);
        this.PC_HOVER_CALLBACKS[i]();
        this.PC_HOVER_CALLBACKS[i] = null;
      }
    }
  }

  /**
   * elementのtop位置を返す
   */
  getOffset(selector) {
    let rect = null;
    if (typeof selector === 'string') {
      rect = document.querySelector(selector).getBoundingClientRect();
    } else if (selector !== undefined) {
      rect = selector.getBoundingClientRect();
    }

    if (rect) {
      return {
        orig: rect,
        offset: {
          top: rect.top + this.getScrollTop(),
          left: rect.left
        }
      }
    }

    return null;
  }

  /**
   * TweenMax用カスタムイージングを返す
   */
  getCustomEase(name) {
    return this.ease[name];
  }

  /**
   * MatchMedia（メディアクエリ）による判別
   */
  getMatchMedia() {
    return window.matchMedia('(max-width: 900px)').matches;
  }

  /**
   * 現在のデバイスを判別（ブラウザ幅）
   */
  setDevice() {
    return this.getMatchMedia() ? 'sp' : 'pc';
  }

  /**
   * スムーススクロール
   */
  scrollToY(posY, duration) {
    TweenMax.to(window, duration, {scrollTo:{y: posY, autoKill: false}});
  }

  /**
   * クエリストリングを配列にする
   */
  parseQuery() {
    let vars = [], max = 0, hash = "", array = "";
    const url = window.location.search;

    hash  = url.slice(1).split('&');
    max = hash.length;
    for (let i = 0; i < max; i++) {
      array = hash[i].split('=');
      vars.push(array[0]);
      vars[array[0]] = array[1];
    }

    return vars;
  }

  /**
   * クエリストリング取得
   */
  getURLParams() {
    const parsed = this.parseQuery();
    return parsed;
  }

  /**
   * aタグを探す
   */
  getHref(el) {
    if (!el)
    {
      return undefined;
    }

    if (el.getAttribute && typeof el.getAttribute('xlink:href') === 'string')
    {
      return el.getAttribute('xlink:href');
    }

    if (typeof el.href === 'string')
    {
      return el.href;
    }

    return undefined;
  }

  /**
   * 文字列をバイト数でカウントする
   */
  byteCount(str) {
    let r = 0;
    for (let i = 0; i < str.length; i++) {
      const c = str.charAt(i);

      if (this.isZenkaku(c)) {
        r += 2;
      } else {
        r += 1.3;
      }
    }

    return r;
  }

  isZenkaku(str) {
    return (str.match(/^[\u0020-\u007e]+$/)) ? false : true;
  }

  byteAjust(str, count) {
    let r = 0, line = '';
    for (let i = 0; i < str.length; i++) {
      const c = str.charAt(i);

      if (this.isZenkaku(c)) {
        r += 2;
      } else {
        r += 1.3;
      }

      if (r > count) break;

      line += str.charAt(i);

      //console.log(r, count, line);
    }

    return line + '…';
  }

  getCurrentState() {
    if (location.pathname === '/' || location.pathname === '/en/') {
      return 'home';
    } else {
      return null;
    }
  }

  getHref(el) {
    if (!el)
    {
      return undefined;
    }

    if (el.getAttribute && typeof el.getAttribute('xlink:href') === 'string')
    {
      return el.getAttribute('xlink:href');
    }

    if (typeof el.href === 'string' && el.getAttribute('href'))
    {
      return el.href;
    }

    return undefined;
  }

  checkMyself(el, url) {
    const base = location.protocol + '//' + location.hostname + location.pathname + location.search;
    // ハッシュ
    if (url.replace(base, '').indexOf('#') === 0) {
      return true;
    }
  }

  checkExternal(el, url) {
    // traget="_blank"
    if (el.target && el.target === '_blank') return true;
    // 拡張子が該当する場合はtarget="_blank"に
    if (/\.(xlsx?|docx?|pptx?|pdf|jpe?g|png|gif|svg)/.test(url.toLowerCase())) {
      el.setAttribute('target','_blank');
      return true;
    }
    // wp
    if (url.indexOf('/wp-admin') > -1 || url.indexOf('/wp-login') > -1) return true;
    // PJAX除外class名
    if (el.classList.contains('no-pjax')) return true;
    // protocol違い
    if (location.protocol !== el.protocol || location.hostname !== el.hostname) return true;
  }

  // 配列シャッフルして返す
  arrShuffle(arr) {
    for (let i = arr.length - 1; i >= 0; i--){
      // 0~iのランダムな数値を取得
      let rand = Math.floor( Math.random() * ( i + 1 ) );
      // 配列の数値を入れ替える
      [arr[i], arr[rand]] = [arr[rand], arr[i]];
    }
    return arr;
  }

  // ----------------------------------------
  // minからmaxまでランダム
  // ----------------------------------------
  random(min, max) {
    return Math.random() * (max - min) + min;
  }

  // ----------------------------------------
  // minからmaxまでランダム int
  // ----------------------------------------
  randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  // ----------------------------------------
  // -valからvalまでランダム
  // ----------------------------------------
  range(val) {
    return this.random(-val, val);
  }

  // ----------------------------------------
  // 配列の中ランダム
  // ----------------------------------------
  randomArr(arr) {
    return arr[this.randomInt(0, arr.length - 1)]
  }

  // 1 / rangeの確率でtrueを取得
  // -----------------------------------
  // @range : 2以上の分母(int)
  // return : true or false(boolean)
  // -----------------------------------
  hit(_range) {
    return (this.randomInt(0, _range - 1) == 0)
  }

  // ----------------------------------------
  // minからmaxまでランダム 半分の確率で-をつける
  // ----------------------------------------
  random2(min, max) {
    let val = Math.random() * (max - min) + min;
    if(Math.random() > 0.5) {
      val *= -1;
    }
    return val;
  }

  getOffsetTop(el) {
    let targetY = el.offsetTop;
    let parent = el.offsetParent;
    while (parent && parent != document.body) {
      targetY += parent.offsetTop;
      parent = parent.offsetParent;
    }
    return {top: targetY, parent: parent};
  }

  shiftBox(el) {
    const num = this.randomInt(0, 6);
    if (num > 0) {
      el.className = el.className + ` u-shift-lt${num}`;
    }
  }

  /**
   * イージング
   */
  /*easeOut(p) {
    return p * (2 - p);
  }*/

  outQuad(t){
    return -t*(t-2);
  }

  quad(t){
    return t*t;
  }

  cubic(t){
    return t*t*t;
  }

  quart(t){
    return t*t*t*t;
  }

  quint(t){
    return t*t*t*t*t;
  }

  expo(t) {
    return Math.pow(2,-(1- t) * 10);
  }

  QuadOut(t) {
    return 1 - this.quad(1 - t);
  }

  CubicOut(t) {
    return 1 - this.cubic(1 - t);
  }

  QuartOut(t) {
    return 1 - this.quart(1 - t);
  }

  QuintOut(t) {
    return 1 - this.quint(1 - t);
  }

  ExpoOut(t) {
    return 1 - this.expo(1 - t);
  }
}

const AnyStoreInstance = new AnyStore();

// 既存のプロパティ属性と値の変更、および新しいプロパティの追加を防止
Object.freeze(AnyStoreInstance);

export default AnyStoreInstance;